export default "__VITE_ASSET__C_B2smRL__"